import React, { useEffect, useState } from 'react';
import { Clock, ShieldCheck, AlertTriangle, ChevronDown, Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 40
  });
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [selectedPlan, setSelectedPlan] = useState<'pro' | 'basic'>('pro');
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  const faqs = [{
    q: '¿Sirve para cualquier tipo de moto?',
    a: 'Sí, los checklists y guías están diseñados para adaptarse a distintos tipos de motos (Enduro, Pista, Touring, Street, etc.).'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago, recibís un correo con el acceso directo a todo el material en formato PDF, listo para descargar o ver desde tu celular.'
  }, {
    q: '¿Qué lo diferencia del material gratuito de YouTube?',
    a: 'Acá tenés un sistema paso a paso, ordenado y sin relleno. No perdés horas buscando videos ni dudando si la información es correcta. Es ir directo al grano.'
  }, {
    q: '¿Tiene garantía real?',
    a: '100% real. Tenés 7 días para probar todo el material. Si no te sirve, pedís la devolución y te reintegramos el dinero sin hacer preguntas.'
  }];
  return <section id="pricing" className="py-24 bg-surface border-t border-white/5 relative overflow-hidden" data-id="element-190">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[500px] bg-cyan/5 rounded-full blur-[150px] pointer-events-none" data-id="element-191"></div>

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-192">
        {/* Countdown */}
        <FadeIn data-id="element-193">
          <div className="text-center mb-16" data-id="element-194">
            <h2 className="text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-195">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h2>

            <div className="flex justify-center gap-4 mb-6" data-id="element-196">
              <div className="bg-background border border-cyan/30 w-20 h-24 md:w-24 md:h-28 rounded-xl flex flex-col items-center justify-center shadow-[0_0_15px_rgba(0,229,255,0.1)]" data-id="element-197">
                <span className="text-4xl md:text-5xl font-bold text-cyan font-heading" data-id="element-198">
                  {formatTime(timeLeft.h)}
                </span>
                <span className="text-xs text-gray-400 uppercase mt-2" data-id="element-199">
                  Horas
                </span>
              </div>
              <div className="text-4xl md:text-5xl font-bold text-cyan/50 self-center pb-6" data-id="element-200">
                :
              </div>
              <div className="bg-background border border-cyan/30 w-20 h-24 md:w-24 md:h-28 rounded-xl flex flex-col items-center justify-center shadow-[0_0_15px_rgba(0,229,255,0.1)]" data-id="element-201">
                <span className="text-4xl md:text-5xl font-bold text-cyan font-heading" data-id="element-202">
                  {formatTime(timeLeft.m)}
                </span>
                <span className="text-xs text-gray-400 uppercase mt-2" data-id="element-203">
                  Min
                </span>
              </div>
              <div className="text-4xl md:text-5xl font-bold text-cyan/50 self-center pb-6" data-id="element-204">
                :
              </div>
              <div className="bg-background border border-cyan/30 w-20 h-24 md:w-24 md:h-28 rounded-xl flex flex-col items-center justify-center shadow-[0_0_15px_rgba(0,229,255,0.1)]" data-id="element-205">
                <span className="text-4xl md:text-5xl font-bold text-cyan font-heading" data-id="element-206">
                  {formatTime(timeLeft.s)}
                </span>
                <span className="text-xs text-gray-400 uppercase mt-2" data-id="element-207">
                  Seg
                </span>
              </div>
            </div>

            <div className="inline-flex items-center gap-2 text-yellow bg-yellow/10 px-4 py-2 rounded-full text-sm font-medium mb-6" data-id="element-208">
              <AlertTriangle className="w-4 h-4" data-id="element-209" />
              ⚠️ Después sube $8.000 ARS. No vuelve.
            </div>

            {/* Scarcity Bar */}
            <div className="max-w-md mx-auto bg-surfaceLight/50 rounded-xl p-4 border border-red-500/20" data-id="element-210">
              <div className="flex items-center justify-between mb-2" data-id="element-211">
                <span className="text-red-400 font-bold text-sm flex items-center gap-2" data-id="element-212">
                  <span className="relative flex h-2 w-2" data-id="element-213">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-214"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-215"></span>
                  </span>
                  🔴 Quedan pocos cupos al precio de lanzamiento
                </span>
              </div>
              <div className="w-full bg-background rounded-full h-2.5 mb-2 overflow-hidden border border-white/5" data-id="element-216">
                <div className="bg-gradient-to-r from-red-500 to-red-400 h-2.5 rounded-full" style={{
                width: '68%'
              }} data-id="element-217"></div>
              </div>
              <p className="text-xs text-gray-400 text-right" data-id="element-218">
                68% de los cupos ya tomados
              </p>
            </div>
          </div>
        </FadeIn>

        {/* Pricing Selector */}
        <FadeIn delay={0.1} data-id="element-219">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-10" data-id="element-220">
            ELEGÍ TU <span className="text-cyan" data-id="element-221">MEGA PACK</span>
          </h2>
        </FadeIn>

        <div id="elegir-plan" className="max-w-2xl mx-auto mb-24" data-id="element-222">
          {/* Basic Plan Option */}
          <FadeIn delay={0.1} data-id="element-223">
            <button onClick={() => setSelectedPlan('basic')} className={`w-full text-left rounded-2xl p-6 mb-4 transition-all duration-300 border-2 ${selectedPlan === 'basic' ? 'border-cyan shadow-[0_0_25px_rgba(0,229,255,0.15)] bg-surfaceLight/60' : 'border-white/10 bg-background hover:border-white/20'}`} data-id="element-224">
              <div className="flex items-start gap-4" data-id="element-225">
                {/* Radio */}
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'basic' ? 'border-cyan' : 'border-gray-500'}`} data-id="element-226">
                  {selectedPlan === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-cyan" data-id="element-227"></div>}
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0" data-id="element-228">
                  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-229">
                    <div data-id="element-230">
                      <h3 className="text-xl font-bold text-white flex items-center gap-2 mb-1" data-id="element-231">
                        <span data-id="element-232">📘</span> MEGA PACK MOTOCICLISTA
                      </h3>
                      <p className="text-gray-400 text-sm mb-3" data-id="element-233">
                        6 Módulos + 5 Bonos
                      </p>
                      <div className="bg-surfaceLight/50 px-3 py-2 rounded-lg border border-white/5 text-xs text-gray-300 inline-block" data-id="element-234">
                        <span className="font-semibold text-white" data-id="element-235">
                          Ideal para:
                        </span>{' '}
                        Motociclistas que quieren rodar seguros y preparados
                      </div>
                    </div>
                    <div className="sm:text-right shrink-0" data-id="element-236">
                      <span className="text-gray-500 line-through text-sm block" data-id="element-237">
                        $51.000
                      </span>
                      <span className="text-3xl font-bold text-white font-heading" data-id="element-238">
                        $19.990
                      </span>
                      <span className="text-sm text-gray-400 ml-1" data-id="element-239">ARS</span>
                    </div>
                  </div>
                </div>
              </div>
            </button>
          </FadeIn>

          {/* Pro Plan Option */}
          <FadeIn delay={0.2} data-id="element-240">
            <div className="relative" data-id="element-241">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-242">
                <span className="bg-cyan text-background font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wider" data-id="element-243">
                  Más Elegido ⭐
                </span>
              </div>
              <button onClick={() => setSelectedPlan('pro')} className={`w-full text-left rounded-2xl p-6 transition-all duration-300 border-2 ${selectedPlan === 'pro' ? 'border-cyan shadow-[0_0_25px_rgba(0,229,255,0.15)] bg-surfaceLight/60' : 'border-white/10 bg-background hover:border-white/20'}`} data-id="element-244">
                <div className="flex items-start gap-4" data-id="element-245">
                  {/* Radio */}
                  <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'pro' ? 'border-cyan' : 'border-gray-500'}`} data-id="element-246">
                    {selectedPlan === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-cyan" data-id="element-247"></div>}
                  </div>

                  {/* Content */}
                  <div className="flex-1 min-w-0" data-id="element-248">
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-249">
                      <div data-id="element-250">
                        <h3 className="text-xl font-bold text-white flex items-center gap-2 mb-1" data-id="element-251">
                          <span data-id="element-252">🏆</span> MEGA PACK + MOTO TALLER PRO{' '}
                          <span className="text-yellow" data-id="element-253">⭐</span>
                        </h3>
                        <p className="text-cyan text-sm font-medium mb-3" data-id="element-254">
                          6 Módulos + 5 Bonos + Sistema Emprendimiento completo
                        </p>
                        <div className="bg-cyan/5 px-3 py-2 rounded-lg border border-cyan/20 text-xs text-gray-300 inline-block" data-id="element-255">
                          <span className="font-semibold text-white" data-id="element-256">
                            Ideal para:
                          </span>{' '}
                          Motociclistas que además quieren emprender con
                          mecánica
                        </div>
                      </div>
                      <div className="sm:text-right shrink-0" data-id="element-257">
                        <span className="text-gray-500 line-through text-sm block" data-id="element-258">
                          $69.000
                        </span>
                        <span className="text-3xl font-bold text-cyan font-heading" data-id="element-259">
                          $27.990
                        </span>
                        <span className="text-sm text-cyan/70 ml-1" data-id="element-260">ARS</span>
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </FadeIn>

          {/* Single CTA Button */}
          <FadeIn delay={0.3} data-id="element-261">
            <a href={selectedPlan === 'pro' ? 'https://fegion.shop/cart/46537415327883:1' : 'https://fegion.shop/cart/46537414901899:1'} className="block w-full mt-6 py-5 text-center rounded-2xl font-bold text-background bg-cyan hover:bg-cyan/90 transition-all animate-pulse-glow shadow-lg uppercase tracking-wider text-lg" data-id="element-262">
              {selectedPlan === 'pro' ? '→ QUIERO EL MEGA PACK + MOTO TALLER PRO' : '→ QUIERO MI MEGA PACK'}
            </a>
          </FadeIn>
        </div>

        {/* Pricing Cards */}
        <FadeIn delay={0.1} data-id="element-263"></FadeIn>

        {/* Moto Taller Pro Comparison Table */}
        <FadeIn delay={0.2} data-id="element-264">
          <div className="max-w-4xl mx-auto mb-16" data-id="element-265">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2 text-center" data-id="element-266">
              🔧 ¿QUÉ AGREGA EL MOTO TALLER PRO?
            </h3>
            <p className="text-gray-400 text-center mb-6" data-id="element-267">
              Sistema completo para emprender con mecánica de motos
            </p>
            <p className="text-sm text-gray-400 mb-2 md:hidden text-center" data-id="element-268">
              ← Scroll to see full table →
            </p>
            <div className="overflow-x-auto pb-4" data-id="element-269">
              <table className="w-full min-w-[600px] text-left border-collapse" data-id="element-270">
                <thead data-id="element-271">
                  <tr data-id="element-272">
                    <th className="p-4 border-b border-white/10 text-gray-300 font-semibold bg-surfaceLight/30 rounded-tl-xl" data-id="element-273">
                      Situación
                    </th>
                    <th className="p-4 border-b border-white/10 text-red-400 font-semibold bg-red-500/5" data-id="element-274">
                      ❌ Sin Moto Taller Pro
                    </th>
                    <th className="p-4 border-b border-white/10 text-cyan font-semibold bg-cyan/5 rounded-tr-xl" data-id="element-275">
                      ✅ Con Moto Taller Pro
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm md:text-base" data-id="element-276">
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-277">
                    <td className="p-4 text-gray-300" data-id="element-278">
                      Querés emprender con mecánica pero no sabés por dónde
                      empezar
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-279">
                      Improvisás o no arrancás nunca
                    </td>
                    <td className="p-4 text-white bg-cyan/5 font-medium" data-id="element-280">
                      Sistema de arranque listo. Paso a paso.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-281">
                    <td className="p-4 text-gray-300" data-id="element-282">
                      Un cliente te pregunta el precio de un servicio
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-283">
                      Tirás un número sin saber si es justo
                    </td>
                    <td className="p-4 text-white bg-cyan/5 font-medium" data-id="element-284">
                      Lista de precios profesional. Ya está.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-285">
                    <td className="p-4 text-gray-300" data-id="element-286">
                      Necesitás organizar tu taller o espacio de trabajo
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-287">
                      Lo armás como podés
                    </td>
                    <td className="p-4 text-white bg-cyan/5 font-medium" data-id="element-288">
                      Protocolo de organización listo.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-289">
                    <td className="p-4 text-gray-300" data-id="element-290">
                      Un cliente quiere saber qué le hiciste a la moto
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-291">
                      No tenés registro formal
                    </td>
                    <td className="p-4 text-white bg-cyan/5 font-medium" data-id="element-292">
                      Ficha de servicio profesional. Lista.
                    </td>
                  </tr>
                  <tr className="hover:bg-white/5 transition-colors" data-id="element-293">
                    <td className="p-4 text-gray-300 rounded-bl-xl" data-id="element-294">
                      Querés conseguir tus primeros clientes
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-295">
                      No sabés cómo promocionarte
                    </td>
                    <td className="p-4 text-white bg-cyan/5 font-medium rounded-br-xl" data-id="element-296">
                      Scripts y estrategia de captación. Listos.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </FadeIn>

        {/* Kit Includes */}
        <FadeIn delay={0.3} data-id="element-297">
          <div className="max-w-4xl mx-auto mb-20 bg-surfaceLight/30 rounded-3xl p-8 border border-white/5" data-id="element-298">
            <h3 className="text-2xl font-bold text-white mb-8 text-center" data-id="element-299">
              ✅ EL MOTO TALLER PRO INCLUYE:
            </h3>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-300">
              {['🔧 Sistema de arranque para tu taller desde cero', '💰 Lista de precios por servicio lista para usar', '📋 Fichas de servicio al cliente profesionales', '📣 Scripts para conseguir tus primeros clientes', '🗂️ Protocolo de organización del taller', '📊 Registro de ingresos y servicios simple', '🤝 Cómo fidelizar clientes y generar recomendaciones', '🚀 Plan de los primeros 30 días de tu emprendimiento'].map((item, i) => <div key={i} className="flex items-start gap-3 bg-background/50 p-4 rounded-xl border border-white/5" data-id="element-301">
                  <span className="text-gray-300" data-id="element-302">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Testimonials */}
        <FadeIn delay={0.4} data-id="element-303">
          <div className="max-w-5xl mx-auto mb-24" data-id="element-304">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-10 text-center" data-id="element-305">
              ❤️ MÁS MOTOCICLISTAS QUE YA LO TIENEN
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-306">
              {[{
              name: 'Cecilia R.',
              loc: '📍 Mendoza',
              plan: 'Mega Pack + Moto Taller Pro',
              text: 'El sistema de arranque me sacó del "algún día arranco el taller". En 30 días ya tenía mis primeros clientes.'
            }, {
              name: 'Roberto M.',
              loc: '📍 Buenos Aires',
              plan: 'Motociclista',
              text: 'Con los scripts para el mecánico, en 10 minutos supe exactamente qué decirle y cuánto debía costarme.'
            }, {
              name: 'Sofía C.',
              loc: '📍 La Plata',
              plan: 'Motociclista',
              text: 'Hice el diagnóstico en 3 minutos antes de salir y encontré algo que me hubiera dejado tirada en la ruta.'
            }, {
              name: 'Pablo A.',
              loc: '📍 Neuquén',
              plan: 'Emprendedor',
              text: 'El Plan 30 días del Moto Taller Pro fue un antes y un después. Hoy tengo mi propio taller funcionando.'
            }].map((t, i) => <div key={i} className="bg-surfaceLight p-6 rounded-2xl border border-white/5" data-id="element-307">
                  <div className="flex gap-1 mb-3" data-id="element-308">
                    {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-yellow text-yellow" data-id="element-309" />)}
                  </div>
                  <p className="text-gray-300 mb-4 italic" data-id="element-310">"{t.text}"</p>
                  <div className="text-sm" data-id="element-311">
                    <span className="font-bold text-white" data-id="element-312">{t.name}</span>
                    <span className="text-gray-500 mx-2" data-id="element-313">|</span>
                    <span className="text-gray-400" data-id="element-314">{t.loc}</span>
                    <span className="text-gray-500 mx-2" data-id="element-315">|</span>
                    <span className="text-cyan text-xs" data-id="element-316">{t.plan}</span>
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Guarantee */}
        <FadeIn delay={0.5} data-id="element-317">
          <div className="max-w-3xl mx-auto bg-surfaceLight/50 rounded-3xl p-8 md:p-12 border border-white/5 text-center" data-id="element-318">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/5 mb-6" data-id="element-319">
              <ShieldCheck className="w-8 h-8 text-white" data-id="element-320" />
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-321">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h3>
            <p className="text-gray-300 text-lg mb-6" data-id="element-322">
              Abrís los módulos. Los usás en la ruta o en tu taller. Si en 7
              días no es lo que esperabas:
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 mb-6 text-white font-medium" data-id="element-323">
              <div className="flex items-center justify-center gap-2" data-id="element-324">
                <span className="text-green-400" data-id="element-325">✅</span> Devolución del 100%
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-326">
                <span className="text-green-400" data-id="element-327">✅</span> Sin formularios, sin
                drama.
              </div>
            </div>
            <div className="inline-block bg-background px-4 py-2 rounded-lg border border-white/10 text-sm text-gray-400" data-id="element-328">
              Tasa de devoluciones: menos del 1%.
            </div>
          </div>
        </FadeIn>

        {/* FAQ */}
        <FadeIn delay={0.6} data-id="element-329">
          <div className="max-w-3xl mx-auto mt-24" data-id="element-330">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center" data-id="element-331">
              ❓ LO QUE MÁS NOS PREGUNTAN
            </h3>
            <div className="space-y-4" data-id="element-332">
              {faqs.map((faq, i) => <div key={i} className="bg-surfaceLight border border-white/5 rounded-xl overflow-hidden" data-id="element-333">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none" data-id="element-334">
                    <span className="font-medium text-white pr-4" data-id="element-335">{faq.q}</span>
                    <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform shrink-0 ${openFaq === i ? 'rotate-180' : ''}`} data-id="element-336" />
                  </button>
                  {openFaq === i && <div className="px-6 pb-4 text-gray-400" data-id="element-337">{faq.a}</div>}
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}